import instance, { instanceV2 } from "../../api";
import { Roles } from "../../config";

const branchApi = {
    getBranch: (id) => {
        return instance().get(`/branches/${id}/full`).then(res => res.data)
    },
    getBranchReferralConfig: (branchID) => {
        return instanceV2().get(`/branches/${branchID}/referral/config`).then(res => res.data)
    },
    putBranchReferralConfig: (branchID, data) => {
        return instanceV2().put(`/branches/${branchID}/referral/config`, data).then(res => res.data)
    },
    enableBranchReferral: (branchID) => {
        return instanceV2().patch(`/branches/${branchID}/configuration/referral/enable`).then(res => res.data)
    },
    disableBranchReferral: (branchID) => {
        return instanceV2().patch(`/branches/${branchID}/configuration/referral/disable`).then(res => res.data)
    },
    postBranchReferralCampaign: (branchID, formData) => {
        return instanceV2().post(`/branches/${branchID}/referral/send-campaign`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => res.data)
    },
    getBranchCertificates: (id) => {
        return instance().get(`/branches/${id}/certificates`).then(res => res.data)
    },
    postBranchCertificate: (id, data) => {
        return instance().post(`/branches/${id}/certificates`, data).then(res => res.data)
    },
    postSendBranchCertificate: (id, data) => {
        return instance().post(`/branches/${id}/certificates/send`, data).then(res => res.data)
    },
    putBranchCertificate: (id, certificateId, data) => {
        return instance().put(`/branches/${id}/certificates/${certificateId}`, data).then(res => res.data)
    },
    deleteBranchCertificate: (id, cId) => {
        return instance().delete(`/branches/${id}/certificates/${cId}`).then(res => res.data)
    },
    getNotificationsExcludedUsers: (id) => {
        return instance().get(`/branches/${id}/notifications/excluded-users`).then(res => res.data)
    },
    deleteNotificationsExcludedUsers: (id, userId) => {
        return instance().delete(`/branches/${id}/notifications/excluded-users/${userId}`).then(res => res.data)
    },
    getReviews: (id, params, role) => {
        if (role === Roles.ADMINISTRATOR) {
            return instance().get(`/branches/group/${id}/reviews/analytics`, { params }).then(res => res.data)
        } else {
            return instance().get(`/branches/${id}/reviews/analytics`, { params }).then(res => res.data)
        }
    },
    changeWorkingHours: (id, data) => {
        return instance().post(`/branches/${id}/workhours`, data).then(res => res.data)
    },
    postBranchTagConfiguration: (branchId, data) => {
        return instance().post(`/branches/${branchId}/tags/configuration`, data).then(res => res.data)
    },
    postBranchesConfigurationNotifcationToggles: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/notification-toggles`, data).then(res => res.data)
    },
    putBranchTagConfiguration: (branchId, tadId, data) => {
        return instance().put(`/branches/${branchId}/tags/configuration/${tadId}`, data).then(res => res.data)
    },
    putWhatsappReview: (branchId, data) => {
        return instance().put(`/branches/${branchId}/configuration/whatsapp-review`, data).then(res => res.data)
    },
    postBranchTagCustomer: (branchId, data) => {
        return instance().post(`/branches/${branchId}/tags/customers`, data).then(res => res.data)
    },
    postBranchTagCustomersActions: (branchId, data) => {
        return instance().post(`/branches/${branchId}/tags/customers/actions`, data).then(res => res.data)
    },
    putBranchTagCustomer: (branchId, userId, data) => {
        return instance().put(`/branches/${branchId}/tags/customers/${userId}`, data).then(res => res.data)
    },
    getTagCustomers: (branchId, tadId, params) => {
        return instance().get(`/branches/${branchId}/tags/customers/${tadId}`, {params}).then(res => res.data)
    },
    getAnalyticTags: (branchId) => {
        return instance().get(`/branches/${branchId}/tags/analytics`).then(res => res.data)
    },
    deleteBranchTag: (branchId, tagId) => {
        return instance().delete(`/branches/${branchId}/tags/configuration/${tagId}`).then(res => res.data)
    },
    deleteBranchTagUser: (branchId, tagId, userId) => {
        return instance().delete(`/branches/${branchId}/tags/customers/${userId}/${tagId}`).then(res => res.data)
    },
    postBranchTagBulk: (branchId, data) => {
        return instance().post(`/branches/${branchId}/tags/customers/bulk`, data).then(res => res.data)
    },
    getCustomerPrivateBranch: (branchId, userId) => {
        return instance().get(`/branches/${branchId}/customers/${userId}/private-branch`).then(res => res.data)
    },
    changeInfo: (id, data) => {
        // UpdateBranchInfoRequest includes both business user and branch fields
        return instance().post(`/branches/${id}/info`, data).then(res => res.data)
    },
    addBanner: (id, formData) => {
        return instance().post(`/branches/${id}/banners`, formData).then(res => res.data)
    },
    changeBrandedBonusCardBanner: (id, formData) => {
        return instance().post(`/branches/${id}/configuration/branded-bonus-card`, formData).then(res => res.data)
    },
    changeNotification: (id, data) => {
        return instance().post(`/branches/${id}/configuration/mailing`, data).then(res => res.data)
    },
    changeReportsContacts: (id, data) => {
        return instance().put(`/branches/${id}/reports/contacts`, data).then(res => res.data)
    },
    changeLocales: (id, data) => {
        return instance().patch(`/branches/${id}/locales`, data).then(res => res.data)
    },
    deleteBanner: (branchId, bannerId) => {
        return instance().delete(`/branches/${branchId}/banners/${bannerId}`).then(res => res.data)
    },
    changeIcon: (branchId, formData) => {
        return instance().post(`/branches/${branchId}/icon`, formData).then(res => res.data)
    },
    changePrivateCashbackExpireDate: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/private-cashback/expire-date`, data).then(res => res.data)
    },
    changePrivateCashbackSendCodeToCustomer: (branchId, data) => {
        return instance().put(`/branches/${branchId}/configuration/private-cashback/send-code-to-customer`, data).then(res => res.data)
    },
    changeAutoMailing: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/auto-notification`, data).then(res => res.data)
    },
    postNotificationsBlacklist: (branchId, data) => {
        return instance().post(`/branches/${branchId}/notifications/blacklist`, data).then(res => res.data)
    },
    updateBonusForBirthday: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/birthday-bonus`, data).then(res => res.data)
    },
    changeWhatsappHeader: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/whatsapp-header`, data).then(res => res.data)
    },
    updateFirstTransactionNotification: (branchId, formData) => {
        return instance().put(`/branches/${branchId}/configuration/first-transaction-notification`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => res.data)
    },
    changeBonusDelay: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/delay-bonuses`, data).then(res => res.data)
    },
    changeSocials: (branchId, data) => {
        return instance().post(`/branches/${branchId}/social`, data).then(res => res.data)
    },
    activatedAwardConfig: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/award/activated`, data).then(res => res.data)
    },
    deactivatedAwardConfig: (branchId) => {
        return instance().post(`/branches/${branchId}/configuration/award/deactivated`, {enabled: false}).then(res => res.data)
    },

    sendPushToCustomers: (branchId, data) => {
        return instance().post(`/branches/${branchId}/send/push/customers`, data).then(res => res.data)
    },
    branchesCustomersUploadedSend: (branchId, data) => {
        return instance().post(`/branches/${branchId}/customers/uploaded/send`, data).then(res => res.data)
    },
    branchesCustomersUploadedStop: (branchId, data) => {
        return instance().post(`/branches/group/${branchId}/customers/uploaded/stop`, data).then(res => res.data)
    },
    branchesBranchCustomersUploadedStopAll: (branchId) => {
        return instance().post(`/branches/${branchId}/customers/uploaded/stop-all`).then(res => res.data)
    },
    branchesSendPushCustomersStop: (branchId) => {
        return instance().patch(`/branches/${branchId}/send/push/customers/stop`).then(res => res.data)
    },
    branchesCustomersUploadedHistory: (groupId) => {
        return instance().get(`/branches/group/${groupId}/customers/uploaded/history`).then(res => res.data)
    },
    branchesSendPushCustomersUploadedHistory: (branchId) => {
        return instance().get(`/branches/${branchId}/send/push/customers/history`).then(res => res.data)
    },
    getTagsAnalyticsCampaigns: (branchId) => {
        return instance().get(`/branches/${branchId}/tags/analytics/campaigns`).then(res => res.data)
    },
    branchesAnalyticCustomersUploadedSend: (groupId, data) => {
        return instance().post(`/branches/group/${groupId}/customers/uploaded/send`, data).then(res => res.data)
    },
    branchesCustomersUploadedMassSendBonuses: (branchId, data) => {
        return instance().post(`/branches/${branchId}/customers/uploaded/mass-send-bonuses`, data).then(res => res.data)
    },
    branchesNotificationsXLSXSend: (branchId, data) => {
        return instance().post(`/branches/${branchId}/notifications/xlsx/send`, data).then(res => res.data)
    },
    branchesCustomersUploadUser: (groupId, data) => {
        return instance().post(`/branches/${groupId}/customers/upload-user`, data).then(res => res.data)
    },
    branchesCustomersUploadUsers: (groupId, data) => {
        return instance().post(`/branches/${groupId}/customers/upload-users-xlsx`, data).then(res => res.data)
    },
    sendBonusesToUsers: (branchId, data) => {
        return instance().post(`/branches/${branchId}/bonuses/users`, data).then(res => res.data)
    },
    changeContractBasic: (brand_id, data) => {
        return instance().put(`/branches/${brand_id}/contract/basic`, data).then(res => res.data)
    },
    changeContractIncreased: (brand_id, data) => {
        return instance().put(`/branches/${brand_id}/contract/increased`, data).then(res => res.data)
    },
    getBranchesSecurityUsers: (id) => {
        return instance().get(`/branches/${id}/security/users`).then(res => res.data)
    },
    addUserToWhiteList: (branchId, phoneNumber, data) => {
        return instance().put(`/branches/${branchId}/configuration/security/blacklist/add-one`, { phone_number: phoneNumber }).then(res => res.data)
    },
    addUserToExcludeList: (branchId, phoneNumber, data) => {
        return instance().put(`/branches/${branchId}/configuration/security/whitelist/add-one`, { phone_number: phoneNumber }).then(res => res.data)
    },
    removeUserFromWhiteList: (branchId, data) => {
        return instance().put(`/branches/${branchId}/configuration/security/blacklist/remove`, { phone_numbers: data }).then(res => res.data)
    },
    excludeUserFromWhiteList: (branchId, data) => {
        return instance().put(`/branches/${branchId}/configuration/security/whitelist/remove`, { phone_numbers: data }).then(res => res.data)
    },
    updateDateLimitForSecurity: (branchId, data) => {
        return instance().put(`/branches/${branchId}/configuration/security/daily-tx-limit`, data).then(res => res.data)
    },
    updateTxCashbackLimitForSecurity: (branchId, data) => {
        return instance().put(`/branches/${branchId}/configuration/security/tx-cashback-limit`, data).then(res => res.data)
    },
    postBonusPromocode: (branchId, data) => {
        return instance().post(`/branches/${branchId}/promocode`, data).then(res => res.data)
    },
    deleteBonusPromocode: (branchId, codeId, data) => {
        return instance().delete(`/branches/${branchId}/promocode/${codeId}`, data).then(res => res.data)
    },
    changeWhatsappProhibitions: (branchId, data) => {
        return instance().post(`/branches/${branchId}/configuration/whatsapp-prohibitions`, data).then(res => res.data)
    },
    getSecuritySuspicionConfig: (branchId) => {
        return instance().get(`/branches/${branchId}/configuration/security/suspicion`).then(res => res.data)
    },
    updateSecuritySuspicionConfig: (branchId, data) => {
        return instance().put(`/branches/${branchId}/configuration/security/suspicion`, data).then(res => res.data)
    },
    getSuspiciousOrders: (branchId, params) => {
        return instance().get(`/branches/${branchId}/suspicious-orders`, { params }).then(res => res.data)
    },
    getChildBirthdays: (branchId, phone) => {
        return instanceV2().get(`/branches/${branchId}/user/child-birthdays`, { params: { phone } }).then(res => res.data)
    },
    addChildBirthday: (branchId, data) => {
        return instanceV2().post(`/branches/${branchId}/user/child-birthdays`, data).then(res => res.data)
    },
    deleteChildBirthday: (branchId, data) => {
        return instanceV2().delete(`/branches/${branchId}/user/child-birthdays`, { data }).then(res => res.data)
    },
    setBotManagerContact: (branchId, data) => {
        return instanceV2().put(`/branches/${branchId}/configuration/set-bot-manager-contact`, data).then(res => res.data)
    },
    getQrRegistrationConfig: (branchId) => {
        return instanceV2().get(`/branches/${branchId}/configuration/qr-registration`).then(res => res.data)
    },
    updateQrRegistrationConfig: (branchId, data) => {
        return instanceV2().put(`/branches/${branchId}/configuration/qr-registration`, data).then(res => res.data)
    },
    uploadQrLogo: (branchId, formData) => {
        return instance().post(`/branches/${branchId}/qr-logo`, formData).then(res => res.data)
    },
    getQrRegistrationQRImage: (branchId) => {
        return instance().get(`/branches/${branchId}/qr-registration/qr-image`, { responseType: 'blob' }).then(res => res.data)
    },
    getBalanceExpiration: (branchId) => {
        return instanceV2().get(`/branches/${branchId}/configuration/balance-expiration`).then(res => res.data)
    },
    updateBalanceExpiration: (branchId, data) => {
        return instanceV2().put(`/branches/${branchId}/configuration/balance-expiration`, data).then(res => res.data)
    },
}

export default branchApi;
